/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { Organization, User } from '../../data/interfaces';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const REQUIRE_LOGIN = 'REQUIRE_LOGIN';

export const USER_INFO_REQUEST = 'USER_INFO_REQUEST';
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export const USER_INFO_FAILURE = 'USER_INFO_FAILURE';

export const USER_ORG_INFO_REQUEST = "USER_ORG_INFO_REQUEST";
export const USER_ORG_INFO_SUCCESS = "USER_ORG_INFO_SUCCESS";
export const USER_ORG_INFO_FAILURE = "USER_ORG_INFO_FAILURE";

export const CHANGE_ORG_REQUEST = "CHANGE_ORG_REQUEST";
export const CHANGE_ORG_SUCCESS = "CHANGE_ORG_SUCCESS";
export const CHANGE_ORG_FAILURE = "CHANGE_ORG_FAILURE";

export const OBTAIN_APIM_TOKEN_REQUEST = 'OBTAIN_APIM_TOKEN_REQUEST';
export const OBTAIN_APIM_TOKEN_SUCCESS = 'OBTAIN_APIM_TOKEN_SUCCESS';
export const OBTAIN_APIM_TOKEN_FAILURE = 'OBTAIN_APIM_TOKEN_FAILURE';

export const ADD_ENTERPRISE_USER_REQUEST = 'ADD_ENTERPRISE_USER_REQUEST';
export const ADD_ENTERPRISE_USER_SUCCESS = 'ADD_ENTERPRISE_USER_SUCCESS';
export const ADD_ENTERPRISE_USER_FAILURE = 'ADD_ENTERPRISE_USER_FAILURE';

export interface UserActions {
    type: typeof USER_LOGIN_REQUEST | typeof USER_LOGIN_SUCCESS | typeof USER_LOGIN_FAILURE |
    typeof REQUIRE_LOGIN | typeof USER_INFO_REQUEST | typeof USER_INFO_SUCCESS | typeof USER_INFO_FAILURE |
    typeof USER_ORG_INFO_REQUEST | typeof USER_ORG_INFO_SUCCESS | typeof USER_ORG_INFO_FAILURE |
    typeof CHANGE_ORG_REQUEST | typeof CHANGE_ORG_SUCCESS | typeof CHANGE_ORG_FAILURE |
    typeof OBTAIN_APIM_TOKEN_FAILURE | typeof OBTAIN_APIM_TOKEN_REQUEST | typeof OBTAIN_APIM_TOKEN_SUCCESS |
    typeof ADD_ENTERPRISE_USER_REQUEST | typeof ADD_ENTERPRISE_USER_SUCCESS | typeof ADD_ENTERPRISE_USER_FAILURE,
    payload?: User | Record<string, unknown> | string | Organization[] | Organization,
    status?: number
}
